// Depends
import { group, subGroup } from '@/helpers/routes'
import { routes as dashboard } from './dashboard'
import { routes as record } from './record'

export default [
  ...group('/app/employee', [
    ...dashboard,
    ...subGroup('/record', record)
  ])
]



// WEBPACK FOOTER //
// ./src/app/employee/routes.js